import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
// import * as Cookies from 'js-cookie'

import auth from './modules/auth'
import header from './modules/header'
import error from './modules/error'
import alerts from './modules/alerts'
import printer from './modules/printer'
import setting from './modules/setting'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    environment: 'local',
    appName: 'sinopsadmin',
    isLoading: true,
  },
  mutations: {
    /**
     * 環境名設定
     */
    setEnvironment(state, payload) {
      state.environment = payload
    },
    /**
     * アプリ名設定
     */
    setAppName(state, payload) {
      state.appName = payload
    },
    /**
     * ローディング切り替え
     */
    setLoading(state, payload) {
      state.isLoading = payload
    },
  },
  actions: {},
  modules: {
    auth,
    header,
    error,
    alerts,
    printer,
    setting,
  },
  plugins: [
    // TODO:
    //   HTML5のLocal Storageを使ってはいけない（翻訳）
    //   https://techracho.bpsinc.jp/hachi8833/2019_10_09/80851
    createPersistedState({
      key: 'sinops-cloud',
      paths: ['setting.companyCd', 'setting.storeCd', 'setting.userName', 'setting.password', 'setting.printerURL', 'setting.formatId', 'setting.halfPriceFormatId'],
      // storage: {
      //   getItem: (key) => Cookies.get(key),
      //   setItem: (key, value) =>
      //     Cookies.set(key, value, { expires: 1, domain: '.sinops.cloud' }),
      //   removeItem: (key) => Cookies.remove(key),
      // }
    })
  ]
})
